import {termsCopy} from './terms-copy.js';
import {language,translate,updateAlternates} from './site-languages.js';
import {localePath,copyText} from './locale-copy.js';
export function createSiteMetadata(React, useLocation) {
  const pages = {
    '/': ['GhostSwap – Cross Network Crypto Exchange | Private , No KYC', 'Compare cryptocurrency swap providers and exchange supported tokens and networks with GhostSwap.'],
    '/contact-us': ['Contact GhostSwap Support | GhostSwap', 'Contact GhostSwap support by email or Telegram for help with your exchange or order.'],
    '/privacy-policy': ['Privacy Policy | GhostSwap', 'Read the GhostSwap privacy policy and learn how information is handled when using the exchange.'],
  };
  return function useSiteMetadata() {
    const { pathname } = useLocation();
    React.useEffect(() => {
      if (pathname === '/swap' || pathname.startsWith('/swap/')) return;
      const page = pathname.replace(/\/$/,'')==='/tos'&&language!=='en'?[termsCopy[language].title+' | GhostSwap',termsCopy[language].title+' — GhostSwap']:pages[pathname];
      const title = pathname==='/'&&language!=='en'?copyText('homeTitle',language)+' | GhostSwap':translate((page?.[0] || 'Exchange status | GhostSwap').replace(' | GhostSwap',''))+' | GhostSwap';
      const description = pathname==='/'&&language!=='en'?copyText('homeDesc',language):translate(page?.[1] || 'View your GhostSwap exchange status.');
      updateAlternates(pathname==='/tos'?'/tos/':pathname,!!page);
      document.title = title;
      const set = (selector, attr, value) => document.querySelector(selector)?.setAttribute(attr, value);
      set('link[rel="canonical"]','href','https://www.ghostswap.app' + localePath(pathname==='/tos'?'/tos/':pathname,language));
      set('meta[name="description"]','content',description);
      set('meta[name="robots"]','content',page ? 'index, follow' : 'noindex, follow');
      for(const selector of ['meta[property="og:title"]','meta[name="twitter:title"]']) set(selector,'content',title);
      for(const selector of ['meta[property="og:description"]','meta[name="twitter:description"]']) set(selector,'content',description);
      set('meta[property="og:url"]','content','https://www.ghostswap.app'+localePath(pathname==='/tos'?'/tos/':pathname,language));
    }, [pathname]);
  };
}
